<template>
  <div class="box2">
    <pageTitle
      title="AI正在重塑千行百业<br/>入局正当时"
      text="抓住全行业产业升级的红利期，抢占AI职业新机遇"
      titleColor="#24375C "
      titColor="#86909C"
    />

    <div class="stats-box">
      <div class="stats-item" v-for="(item, index) in statsList" :key="index">
        <div class="stats-item__num">
          <span class="stats-item__value">{{ item.value }}</span>
          <span class="stats-item__unit">{{ item.unit }}</span>
        </div>
        <p class="stats-item__label">{{ item.label }}</p>
      </div>
    </div>

    <div class="subject-box">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(slide, index) in listSwiper"
          :key="index"
        >
          <div class="card-grid">
            <div
              class="card"
              v-for="(card, cardIndex) in slide.cards"
              :key="cardIndex"
            >
              <div class="card__head">
                <img class="card__icon" :src="card.icon" alt="" />
                <h3 class="card__title">{{ card.title }}</h3>
              </div>
              <ul class="card__list">
                <li v-for="(text, textIndex) in card.items" :key="textIndex">
                  <i class="card__arrow"></i>
                  <span>{{ text }}</span>
                </li>
              </ul>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination-box2"></div>
    </div>

    <ConsultBtn text="获取我的《AI入行分析报告》" />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import ConsultBtn from "./ConsultBtn.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    ConsultBtn,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
          el: ".swiper-pagination-box2",
        },
      },
      statsList: [
        { value: "1.2", unit: "万亿", label: "产业规模" },
        { value: "6200", unit: "+", label: "中国AI企业数量" },
        { value: "500", unit: "万", label: "人才缺口" },
        { value: "135", unit: "亿", label: "智能体市场" },
      ],
      listSwiper: [
        {
          cards: [
            {
              icon: require("../../../assets/coursePage/llm/box2/icon-health.png"),
              title: "医疗健康",
              items: ["百川全科医疗大模型", "讯飞星火医疗大模型"],
            },
            {
              icon: require("../../../assets/coursePage/llm/box2/icon-drive.png"),
              title: "自动驾驶",
              items: ["理想 MindVLA-01", "小鹏 VLA 智能体"],
            },
            {
              icon: require("../../../assets/coursePage/llm/box2/icon-manufacture.png"),
              title: "智能制造",
              items: ["格力明珠大模型", "阿里云通义工业版"],
            },
            {
              icon: require("../../../assets/coursePage/llm/box2/icon-ecommerce.png"),
              title: "电商新零售",
              items: ["阿里妈妈 AI 万相", "Kimi 导购智能体"],
            },
            {
              icon: require("../../../assets/coursePage/llm/box2/icon-logistics.png"),
              title: "物流供应链",
              items: ["顺丰丰知大模型", "京东供应链大模型"],
            },
            {
              icon: require("../../../assets/coursePage/llm/box2/icon-fintech.png"),
              title: "金融科技",
              items: ["平安银行智能体矩阵", "工银智涌"],
            },
          ],
        },
        {
          cards: [
            {
              icon: require("../../../assets/coursePage/llm/box2/icon-cross.png"),
              title: "通用跨领域",
              items: ["豆包/腾讯元宝", "Kimi/DeepSeek"],
            },
            {
              icon: require("../../../assets/coursePage/llm/box2/icon-code-dev.png"),
              title: "代码开发",
              items: ["DeepSeek-Coder-V3", "通义灵码"],
            },
            {
              icon: require("../../../assets/coursePage/llm/box2/icon-education.png"),
              title: "教育科研",
              items: ["教科院46号智能体", "元宝教育 Agent"],
            },
            {
              icon: require("../../../assets/coursePage/llm/box2/icon-law.png"),
              title: "法律政务",
              items: ["“法宣通”智能体", "百度文心政务版"],
            },
            {
              icon: require("../../../assets/coursePage/llm/box2/icon-entertainment.png"),
              title: "泛娱乐传媒",
              items: ["字节 Seedance", "爱奇艺奇智大模型"],
            },
            {
              icon: require("../../../assets/coursePage/llm/box2/icon-service.png"),
              title: "客服",
              items: ["语流 Agent", "乐言智能体"],
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@import './variables.less';

.box2 {
  .btn{
    width:calc(100% - 64px);
    margin:58px auto 0;
  }
  padding: 80px 0;
  width: 100%;
  box-sizing: border-box;
   background: url("../../../assets/coursePage/llm/box2/bg.png") no-repeat;
  background-size: cover;

  /deep/ .course-title {
    font-size: 48px;
    line-height: 68px;
    font-weight: 500;
  }

  /deep/ .course-text {
    font-size: 26px;
    line-height: 44px;
    margin-top: 14px;
  }

  .stats-box {
    display: flex;
    justify-content: space-between;
    margin-top: 56px;
    padding: 0 48px;
  }

  .stats-item {
    text-align: center;

    &__num {
      display: flex;
      align-items: baseline;
      justify-content: center;
      min-height: 52px;
      font-weight: 400;
      .llm-text-gradient();
    }

    &__value {
      font-family: PingFangSC, PingFang SC;
      font-size: 60px;
      font-weight: 400;
      line-height: 52px;
     
    }

    &__unit {
      margin-left: 2px;
      font-family: PingFangSC, PingFang SC;
      font-size: 24px;
      line-height: 34px;
     
    }

    &__label {
      margin-top: 8px;
      font-family: PingFangSC, PingFang SC;
      font-size: 24px;
      font-weight: 400;
     color: #0F2654;
      line-height: 36px;
      white-space:nowrap;
    }
  }

  .subject-box {
    position: relative;
    padding: 10px 32px 10px;
    overflow-x: hidden;
    overflow-y: visible;
  }

  /deep/ .swiper-container {
    overflow: visible;
  }

  .card-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 22px;
    row-gap: 22px;
    /* 为 box-shadow 留出渲染空间，避免被裁切 */
    padding: 30px 0;
    overflow: visible;
  }

  .card {
    padding: 28px 36px 28px 38px;
    box-sizing: border-box;
    border-radius: 36px;
    box-shadow: 0 4px 30px rgba(204, 211, 232, 0.44);
    background: url("../../../assets/coursePage/llm/box2/bg-item.png") no-repeat;
    background-size: 100% 100%;
    overflow: visible;

    &__head {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
    }

    &__icon {
      width: 40px;
      height: 40px;
      flex-shrink: 0;
    }

    &__title {
      margin-left: 16px;
      font-family: PingFangSC, PingFang SC;
      font-size: 32px;
      font-weight: 600;
      color: #072557;
      line-height: 48px;
    }

    &__list {
      li {
        display: flex;
        align-items: flex-start;
        margin-top: 2px;

        &:first-child {
          margin-top: 0;
        }

        span {
          flex: 1;
          font-family: PingFangSC, PingFang SC;
          font-size: 26px;
          font-weight: 400;
          color: #3e4759;
          white-space:nowrap;
          line-height: 38px;
        }
      }
    }

    &__arrow {
    background: url("../../../assets/coursePage/llm/box2/san.png") no-repeat;
    background-size: 100% 100%;
      width: 9.32px;
      height: 12px;
      margin-top: 13px;
      margin-right: 12px;
    
    }
  }

  .swiper-slide {
    width: 100%;
    box-sizing: border-box;
    overflow: visible;
  }

  .swiper-pagination-box2 {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    height: 6px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 12px;
    height: 6px;
    background: rgba(135, 93, 247, 0.16);
    border-radius: 3px;
    margin-right: 8px;
    opacity: 1;
  }

  /deep/ .swiper-pagination-bullet:last-child {
    margin-right: 0;
  }

  /deep/ .swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 24px;
    height: 6px;
    background: #875df7;
    border-radius: 3px;
  }

}
</style>
